function isLoggedIn(user) {
  return user && !user.is_anonymous;
}

export default isLoggedIn;
